document.addEventListener('teeinblue-event-component-injected', () => {
  moveElementAfter('.t4s-liquid_custom_liquid_M9DzQh', '.t4s-product__title');
  moveElementAfter('.t4s-richtext_text_d9XDCd', '.tee-product-price');
  moveElementAfter('.t4s-liquid_custom_liquid_xz7DMc', '.t4s-richtext_text_d9XDCd');
  
});
const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    afterEl.after(targetEl);
  }
};